'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

// Tweens a number for display. Replaces framer's imperative
// `animate(motionValue, to)` — CSS can't interpolate text content, so this is
// one of the few places that still needs a JS loop. requestAnimationFrame keeps
// it off the timer queue and in sync with paint.
//
// Honours prefers-reduced-motion by snapping straight to the target.
export const useCountUp = (to, t0) => {
  const $ = _c(4);
  const durationMs = t0 === undefined ? 1000 : t0;
  const [value, setValue] = useState(0);
  let t1;
  let t2;
  if ($[0] !== durationMs || $[1] !== to) {
    t1 = () => {
      if (typeof window === "undefined" || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        setValue(to);
        return;
      }
      let frame = 0;
      const start = performance.now();
      const ease = _temp;
      const tick = now => {
        const t_0 = Math.min(1, (now - start) / durationMs);
        setValue(to * ease(t_0));
        if (t_0 < 1) {
          frame = requestAnimationFrame(tick);
        }
      };
      frame = requestAnimationFrame(tick);
      return () => cancelAnimationFrame(frame);
    };
    t2 = [to, durationMs];
    $[0] = durationMs;
    $[1] = to;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return value;
};
export default useCountUp;
function _temp(t) {
  return 1 - Math.pow(1 - t, 3);
}